import React, { useState, useEffect } from 'react'
import {Flex} from '/app/src/component'

import ConversationModel from '/app/src/model/Conversation/model';

import TicketActivityList from './TicketActivityList'


export default function TicketActivity() {
    const [customers, setCustomers] = useState({})
    const [latestTickets, setLatestTickets] = useState({})
    const [rooms, setRooms] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect( () => {
        // HACK: Memory leak without checking if component is mounted. Reasons unknown.
        let _mounted = true;
        ConversationModel.getLatestAssignedTickets(5, 0)
            .then( res => {
                if (_mounted) {
                        setCustomers(res.body.conversations.customer)
                        setLatestTickets(res.body.conversations.info)
                        setRooms(res.body.conversations.room)
                        setIsLoading(false)
                }})
        return () => _mounted = false; 
    }, [] )

    return <Flex>
                {
                    <TicketActivityList
                        latestTickets={latestTickets}
                        customers={customers}
                        rooms={rooms}
                        isLoading={isLoading} />
                }
            </Flex>
}


// WEBPACK FOOTER //
// ./src/component/TicketActivity/index.js